import React, { Component } from 'react'
import { ICriteria } from '../../../layout-configuration-panel/ILayoutConfigurationPanel.Interface';
import { CQAppConstant } from '../../../../../app-constants';
import { TemplateSFObjectStore } from '../../../../../store/models/template-object.model';
import GridTemplateConfigurationController from '../../grid-template-config.controller';
import { Utility } from '../../../../../common/utility';
import { GridActionsReducer } from '../action-controller/grid-actions.reducer';
import { CQMasterDataStore } from '../../../../../store/cq-master-data.store';
import { ISubHeading } from '../../../../../common/cq-inputs';
import GridModal, { IState } from '../../grid-modal.component';

const INITIAL_CRITERIA = {
    field: '',
    operator: '',
    compareTo: '',
    isDynamic: false,
    fieldType: 'Child',
    compareFieldType: 'Child',
    referenceField: '',
    referenceTo: '',
    selectedFieldType: '',
    relationshipName: ''
}
export class GridCustomCumponentFieldVisibilityRuletModal extends Component<any, IState>{
    private ruleObject: any;
    private gridTemplateController: GridTemplateConfigurationController;
    private cqUtilityClass: Utility;
    private gridActionsReducer: GridActionsReducer;
    private subHeadings: ISubHeading[] = [
        {
            id: 'Child',
            label: 'Child Fields',
            type:"separator"
        },
        {
            id: 'Parent',
            label: 'Parent Fields',
            type:"separator"
        }
    ];

    constructor(props: any) {
        super(props);
        this.gridTemplateController = new GridTemplateConfigurationController();
        this.gridActionsReducer = new GridActionsReducer();
        this.cqUtilityClass = new Utility();
        this.state = {
            addedCriterias: [{
                field: '',
                operator: '',
                compareTo: '',
                isDynamic: false,
                fieldType: 'Child',
                compareFieldType: 'Child',
                referenceField: '',
                referenceTo: '',
                selectedFieldType: '',
                relationshipName:'',
            }],
            complexLogicQuery: '',
            isVisible: 'true',
            complexLogicVisibility: false,
            isFormValid: true,
            ruleObject: {},
            additionalFields: [],
            shouldRenderDelete: false,
            shouldSkip: false,
            ruleJSON: ''
        };
    }

    componentDidMount() {
        // let ruleObject: any;
        const { selectedCustomComponent, selectedTemplateName, selectedIndex } = this.props;
        const outputConfig: any = CQMasterDataStore.OutputConfig.getStoreData(selectedTemplateName);
        let gridComponentConfigView: any = { ...outputConfig.ruleElements.gridObject.gridComponentConfigView };
        if(gridComponentConfigView.hasOwnProperty('fieldsVisibilityRules')){
            const customComponent = gridComponentConfigView.fieldsVisibilityRules.filter((fieldsVisibilityRule: any) => (
                fieldsVisibilityRule.label === selectedCustomComponent.label && fieldsVisibilityRule.groupName === selectedCustomComponent.groupName
            ));

            if(customComponent.length > 0){
                this.ruleObject = customComponent[0].fields[selectedIndex];

                if (this.ruleObject && Object.keys(this.ruleObject).length > 0) {
                    this.setState({
                        addedCriterias: this.ruleObject.hasOwnProperty('addedCriterias') ? this.ruleObject.addedCriterias : [{
                            field: '',
                            operator: '',
                            compareTo: '',
                            isDynamic: false
                        }],
                        complexLogicQuery: this.ruleObject.hasOwnProperty('complexLogicQuery') ? this.ruleObject.complexLogicQuery : '',
                        complexLogicVisibility: this.ruleObject.hasOwnProperty('complexLogicVisibility') ? this.ruleObject.complexLogicVisibility : false,
                        // additionalFields: this.ruleObject.hasOwnProperty('complexLogicVisibility') ? this.ruleObject.additionalFields:,
                        isVisible: this.ruleObject.hasOwnProperty('isVisible') ? this.ruleObject.isVisible : 'true',
                        shouldRenderDelete: this.ruleObject.hasOwnProperty('isVisible') ? this.ruleObject.isVisible : false
                    });
                }
            }
        }

    }
    
    /**
     * Fuction reuturns required action to be performed 
     * @param actionType reuired aaction name
     * @param value state property to be updated
     */
    onModalActionPerformed = (actionType: string, value?: IState) => {
        switch(actionType) {
            case 'closeModal': 
                this.props.toggleModalVisibility();
                break;
            
            case 'previewRule':
                this.previewRule();
                break;
            
            case 'saveRule':
                this.SaveRule();
                break;

            case 'updateState':
                this.updateState(value!);
                break;
            
            case 'onRuleDelete':
                this.onRuleDelete(); 

            default:
                // do nothing
        }
    }

    /**
     *
     * @returns fields array
     */
    getObjectFields = () => {
        const { mainReferenceObjectFields, standardObjectFields } = TemplateSFObjectStore;
        let parentObjectFields = this.cqUtilityClass.mapField(mainReferenceObjectFields.fields, (field: any) => {
            return {type: 'Parent'}
        });
        parentObjectFields = parentObjectFields.sort((a: any, b: any) => { 
            return a.fieldLabel > b.fieldLabel ? 
                1 : 
                (a.fieldLabel === b.fieldLabel ? 0 : -1); 
        });

        let childObjectFields = this.cqUtilityClass.mapField(standardObjectFields.fields, (field: any) => {
            return {type: 'Child'}
        });

        childObjectFields = childObjectFields.sort((a: any, b: any) => { return a.label > b.label ? 1 : (a.label === b.label ? 0 : -1); });

        return [...childObjectFields, ...parentObjectFields];
    }

    render() {
        const { selectedCustomComponent: { fields: selectedFields }, selectedTemplateName, selectedIndex } = this.props;
        return (
            <GridModal
                modalInfo = {
                    {
                        isFormValid: this.state.isFormValid,
                        label: this.props.ruleObject && Object.keys(this.props.ruleObject).length > 0 ? `Add Rule (Visibility)` : `Edit Rule (Visibility)`,
                        gridType: 'customComponentAction',
                        optionInfo: {
                            options: this.getObjectFields(),
                            subHeading: this.subHeadings
                        }

                    }        
                }
                modalState ={
                    {
                        initialCriteria: INITIAL_CRITERIA,
                        state:this.state,
                    }
                }
                onActionPerformed = {
                    this.onModalActionPerformed
                }
                templateName = {
                    selectedTemplateName
                }
                shouldRenderDelete = {
                    this.state.shouldRenderDelete
                }
                selectedCustomComponent = {
                    { fields: selectedFields }
                }
                selectedIndex = {
                    selectedIndex
                }
            />
            
        );
    }

    /**
     * Updates state and ruleobject for updated property 
     * @param state state property
     */
    updateState = (state: IState) => {
        let stateCopy = this.cqUtilityClass.createObjectDeepCopy(this.state);
        stateCopy = {...stateCopy, ...state};
        this.setState(stateCopy, () => {
            this.updateRuleObject(CQAppConstant.ADDED_CRITERIAS, this.state);
        });
    }
    
    /**
     * Updates rule to be set 
     * @param ruleObjectProperty 
     * @param ruleObjectValue property required for rule to be set
     */
    private updateRuleObject = (ruleObjectProperty: string, ruleObjectValue: any) => {
        // const ruleObject: any = { ...this.state.ruleObject };
        // ruleObject[ruleObjectProperty] = ruleObjectValue;
        this.setRuleObject(ruleObjectValue);
        const isFormValid = this.validateAddRuleForm();
        this.setState({
            isFormValid
        });
    }

    /**
     * 
     * @returns Validates rule for added property
     */
    private validateAddRuleForm = () => {
        if (this.state.isVisible === 'true') {
            let isComplexLogicValid = false;
            const isCriteriaValid = this.state.addedCriterias.every((criteria: ICriteria) => (criteria.field !== ''
                && criteria.operator !== ''
                && ((criteria.operator === CQAppConstant.EXISTS || criteria.operator === CQAppConstant.ISEMPTY) ? true : (criteria.compareTo !== ''))));
            if (this.state.addedCriterias.length === 1 && this.state.complexLogicQuery === '') {
                isComplexLogicValid = true;
            } else if (this.state.addedCriterias.length > 1 && this.state.complexLogicQuery === '') {
                isComplexLogicValid = false;
            } else if (this.state.addedCriterias.length > 1 && this.state.complexLogicQuery !== '') {
                isComplexLogicValid = true;
            }
            if (!isCriteriaValid || !isComplexLogicValid) {
                return true;
            }
            return false;
        } else {
            return false;
        }

    }

    /**
     * 
     * @param ruleObject sets rule object
     */
    private setRuleObject = (ruleObject: any) => {
        this.setState({
            ruleObject
        });
    }

    /**
     * Preview rule for added ruleObject 
     */
    private previewRule = () => {
        const ruleObject: any = this.gridTemplateController.getVisibilityRuleController(this.cqUtilityClass.createObjectDeepCopy(this.state.ruleObject));
        this.setState({ ruleJSON: JSON.stringify(ruleObject, undefined, 2) });
    }

    /**
     * Used to deleted rule in added field
     */
    private onRuleDelete = () => {        
        const { selectedCustomComponent, selectedTemplateName, selectedIndex } = this.props;
        let customComponent: any
        const outputconfig: any = CQMasterDataStore.OutputConfig;

        const ruleElements = outputconfig.getStoreKeyData(selectedTemplateName, 'ruleElements');
        let gridComponentConfigView: any = { ...ruleElements.gridObject.gridComponentConfigView };

        //removed form fieldsVisibility rule
        let index = gridComponentConfigView.fieldsVisibilityRules.findIndex((fieldVisibilityRules: any) => (fieldVisibilityRules.label === selectedCustomComponent.label && fieldVisibilityRules.groupName === selectedCustomComponent.groupName));
        if(index !== -1){
            customComponent = gridComponentConfigView.fieldsVisibilityRules.map((fieldsVisibilityRule: any) => {
                if(fieldsVisibilityRule.label === selectedCustomComponent.label && fieldsVisibilityRule.groupName === selectedCustomComponent.groupName){
                    // fieldsVisibilityRule['fields'].splice(selectedIndex, 1);
                    fieldsVisibilityRule['fields'][selectedIndex] = null;
                }
                return fieldsVisibilityRule;
            });
        }

        this.gridActionsReducer.storeViewModel(this.props.actionType, customComponent, this.props.selectedTemplateName, 'gridComponentConfigView');
        this.props.updateVisibilityRuleObj({visible: true});
        this.props.toggleModalVisibility(this.props.selectedIndex, this.props.selectedCustomComponent);
    }

    /**
     * Saves rule for ruleobject added
     */
    private SaveRule = () => {
        let ruleObject: any = this.state.ruleObject;
        ruleObject.shouldRenderDelete = true;
        delete ruleObject.ruleObject;
        this.setState({ ruleObject }, () => {
            const { selectedCustomComponent, selectedTemplateName, selectedIndex } = this.props;
            const outputconfig: any = CQMasterDataStore.OutputConfig.getStoreData(selectedTemplateName);
            let customComponent: any
            let gridComponentConfigView: any = { ...outputconfig.ruleElements.gridObject.gridComponentConfigView };
            if(gridComponentConfigView.hasOwnProperty('fieldsVisibilityRules')){
                const index = gridComponentConfigView.fieldsVisibilityRules.findIndex((fieldVisibilityRules: any) => (fieldVisibilityRules.label === selectedCustomComponent.label && fieldVisibilityRules.group === selectedCustomComponent.group));
                if(index !== -1){
                    customComponent = gridComponentConfigView.fieldsVisibilityRules.map((fieldsVisibilityRule: any) => {
                        if(fieldsVisibilityRule.label === selectedCustomComponent.label && fieldsVisibilityRule.group === selectedCustomComponent.group){
                            fieldsVisibilityRule['fields'][selectedIndex] = this.cqUtilityClass.createObjectDeepCopy(this.state.ruleObject);
                        }
                        return fieldsVisibilityRule;
                    });
                }else{
                    let fields: any[] = [];
                    fields[selectedIndex] = this.cqUtilityClass.createObjectDeepCopy(this.state.ruleObject);
                    const visibility = JSON.parse(JSON.stringify(gridComponentConfigView.fieldsVisibilityRules));
                    customComponent = [...visibility, {...selectedCustomComponent, fields: fields}];
                }
            }else{
                let fields: any[] = [];
                fields[selectedIndex] = this.cqUtilityClass.createObjectDeepCopy(this.state.ruleObject);
                customComponent = [{...selectedCustomComponent, fields: fields}]
            }
            
            this.gridActionsReducer.storeViewModel(this.props.actionType, customComponent, this.props.selectedTemplateName, 'gridComponentConfigView');
            const ruleObject: any = this.gridTemplateController.getVisibilityRuleController(this.cqUtilityClass.createObjectDeepCopy(this.state.ruleObject));
    
            // let fields: any = [];
            // let parentFields: any = []; 
            // let addtionalFields: any[] = [];
            // let additionalFieldsArray: any[] = []; 
            // const viewConfigGridComponent = { ...CQMasterDataStore.GridObject.gridComponentConfigView };
            // const columnFields = { ...viewConfigGridComponent.fieldsToDisplay };
            // Object.keys(columnFields).forEach((columnField: any) => {
            //     if (typeof columnFields[columnField] === 'object') {
            //         Object.keys(columnFields[columnField]).forEach((currentFieldKey: string) => {
            //             addtionalFields.push(currentFieldKey);
            //             addtionalFields.push(columnFields[columnField][currentFieldKey]);
            //         });
            //     } else {
            //         addtionalFields.push(columnFields[columnField]);
            //     }
            // });
    
            // this.state.addedCriterias.length && this.state.addedCriterias.map((criteria: any) => {
            //     fields.push(criteria.field);
            //     if (criteria.fieldType === 'Parent' && criteria.field) {
            //         // parentFields.push(criteria.field);
            //         if (!addtionalFields.includes(criteria.field)) {
            //             additionalFieldsArray.push(criteria.field);
            //         }
            //     }
            //     if (criteria.isDynamic && criteria.compareTo) {
            //         fields.push(criteria.compareTo);
            //     }
            // });
            
            this.props.updateVisibilityRuleObj(ruleObject);
            this.props.toggleModalVisibility(this.props.selectedIndex, this.props.selectedCustomComponent);
        })

    }

}